import React from 'react';
import {BaseApp, Main, Hydro, Teplo, Econom, Electro, Energo} from '../';

export default class App extends BaseApp {

    render() {
        let loadingNode = <div className="loading"></div>;
        let loading = !this.state.dataReady ? loadingNode: null;
        return (
            <div className="container App" id={this.state.activeScreen}>
                {loading}
                <div className={['row','myMenu'].join(' ')}>
                    <a className={["col-md-2",this.state.activeScreen=='main' ? 'active': ''].join(' ')} id={'mainMenu'} onClick={()=>{this.setActiveScreen('main')}}>Главная</a>
                    <a className={["col-md-2",this.state.activeScreen=='hydro' ? 'active': ''].join(' ')} id={'hydroMenu'}  onClick={()=>{this.setActiveScreen('hydro')}}>Гидравлическая</a>
                    <a className={["col-md-2",this.state.activeScreen=='teplo' ? 'active': ''].join(' ')} id={'teploMenu'} onClick={()=>{this.setActiveScreen('teplo')}}>Тепловая</a>
                    <a className={["col-md-2",this.state.activeScreen=='electro' ? 'active': ''].join(' ')} id={'electroMenu'} onClick={()=>{this.setActiveScreen('electro')}}>Электрическая</a>
                    <a className={["col-md-2",this.state.activeScreen=='econom' ? 'active': ''].join(' ')} id={'economMenu'} onClick={()=>{this.setActiveScreen('econom')}}>Статистическая</a>
                    <a className={["col-md-2",this.state.activeScreen=='energo' ? 'active': ''].join(' ')} id={'energoMenu'} onClick={()=>{this.setActiveScreen('energo')}}>Энергетическая</a>
                </div>
                <div className="screen">
                    <Main psVal={this.state.ps} {...this.props} className={this.state.activeScreen=='main' ? '': 'hidden'}/>
                    <Hydro psVal={this.state.ps} {...this.props} className={this.state.activeScreen=='hydro' ? '': 'hidden'}/>
                    <Teplo psVal={this.state.ps} {...this.props} className={this.state.activeScreen=='teplo' ? '': 'hidden'}/>
                    <Electro psVal={this.state.ps} {...this.props} className={this.state.activeScreen=='electro' ? '': 'hidden'}/>
                    <Econom psVal={this.state.ps} {...this.props} className={this.state.activeScreen=='econom' ? '': 'hidden'}/>
                    <Energo psVal={this.state.ps} {...this.props} className={this.state.activeScreen=='energo' ? '': 'hidden'}/>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/App/index.jsx